import {inject, observer} from 'mobx-react';
import React, {Component} from 'react';
import {action, autorun, observable} from 'mobx';
import MarkupIcon from './MarkupIcon';
import {ReactComponent as LoaderIcon} from '../../../assets/images/studio/markup/iconLoader.svg';

const Loader = () => (
    <div className='icons-loader'>
        {Array.from(Array(4)).map((load, index) => <LoaderIcon key={index}/>)}
    </div>
);

@inject('iconStore')
@observer
class MarkupSubMenuIcons extends Component {
    @observable activeIcon = null;
    @observable isLoading = true;
    @observable secondLoading = true;
    @observable firstIcons = null;
    @observable theRest = null;
    previousProps = null;

    @action handleOnClick = (icon) => action(() => {
        this.activeIcon = icon;
        this.props.handleCanvasImage(icon);
    })

    componentDidMount() {
        autorun(async () => {
            const {type, activeCategory, iconStore} = this.props;
            if (type && activeCategory) {
                await iconStore.loadIcons(type, activeCategory);
            }
        })
    }

    render() {
        const {activeCategory, type, iconStore} = this.props;

        if (!type || !activeCategory || iconStore.isLoadingFirst(type, activeCategory)) {
            return <Loader/>
        }

        return (
            iconStore.getActiveCategory(type, activeCategory).map(icon => {
                if (!icon.panelLoaded) {
                    return <Loader key={icon.key}/>
                }
                const isActive = this.activeIcon?.key === icon.key;
                const svg = isActive ? icon.getResolvedActivePanelIcon() : icon.getResolvedPanelIcon();
                return <MarkupIcon
                    key={icon.key}
                    iconType={icon.type}
                    iconCategory={icon.category}
                    iconName={icon.name}
                    iconKey={icon.key}
                    onClick={this.handleOnClick(icon)}
                    isActive={isActive}
                    activeTextSrc={icon.activeText}
                    iconSrc={svg}
                />
            })
        );
    }
}

export default MarkupSubMenuIcons;
